module.exports = __webpack_public_path__ + "img/img2.8f509d39.png";